// https://github.com/tuupola/jquery_lazyload/tree/1.x

$(document).ready(function () {
    initLazyLoad();
});


/**
 * Lazy loading is determined by the class 'lazy' on the affected images
 */
function initLazyLoad() {
    let $lazy = $('.lazy');

    resolveSize($lazy);

    $lazy.lazyload();
}

/**
 * Use IMG SRC depending on viewport size
 * @param $lazy
 */
function resolveSize($lazy) {
    let size = window.innerWidth;

    let sizeLabel = 'lg';

    if (size < 768) {
        sizeLabel = 'xs';
    }
    else if (size < 992) {
        sizeLabel = 'sm';
    }
    else if (size < 1200) {
        sizeLabel = 'md';
    }

    $lazy.each(function (idx, img) {
        let $img = $(img);
        let responsiveSrc = $img.attr('data-src-' + sizeLabel);

        if (responsiveSrc) {
            $img.attr('data-original', responsiveSrc)
        }
    });
}
